















































import { Component, Prop, Model, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPopover } from "bootstrap-vue";

@Component({
  components: {
    BPopover,
  },
  computed: mapState("gaps", ["status"]),
})
export default class GapStatusPopover extends Vue {
  @Model("change") readonly gap!: any;
  id = "status-popover";
  comment = "";
  loading = false;
  get target() {
    return this.id + "-target-" + this.gap.id;
  }
  async save(status) {
    if (this.loading) return;
    try {
      this.loading = true;
      await this.$store.dispatch("gaps/saveStatus", {
        gapId: this.gap.id,
        statusId: status.id,
        comment: this.comment,
      });
      this.gap.statusId = status.id;
      this.gap.statusName = status.name;
      this.gap.statusBackColor = status.backColor;
      this.gap.statusFontColor = status.fontColor;
      this.loading = false;
      this.close();
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }
  close() {
    if (this.loading) return;
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
}
